module.exports = __webpack_public_path__ + "static/media/bills_false.a5db0e49.png";